import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import { CreateDatasetRequest, DatasetRecord } from "../DatasetRecord";

import { datasetQueryKeys } from "./useDatasetsQuery";

interface CreateDatasetVariables {
  request: CreateDatasetRequest;
  resourceOwnerId: string;
}

export function useCreateDataset() {
  const { datasetService } = useDomainServices();
  const queryClient = useQueryClient();

  return useMutation<DatasetRecord, Error, CreateDatasetVariables>({
    mutationFn: ({ request, resourceOwnerId }) =>
      datasetService.createDataset(request, { resourceOwnerId }),

    onSuccess: function invalidateQuery() {
      return queryClient.invalidateQueries({
        queryKey: datasetQueryKeys.lists(),
      });
    },
  });
}
